import Raven from "raven-js";

// eslint-disable-next-line no-underscore-dangle
Raven.config(process.env.REACT_APP_SENTRY_URL).install();

export default Raven;
